export default __webpack_public_path__ + "static/media/content-deco-1.3e87df22.webp";